import { Box, Tab, Tabs } from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../redux/ReduxHooks';
import { projectSlice } from '../../../redux/ProjectSlice';
import { BuildSubTab, isBuildSubTab, DEFAULT_BUILD_SUB_TAB } from '../../../utils/buildSubTabs';
import ElectronicsContent from '../Snippets/ElectronicsContent';
import MechanismsContent from '../Snippets/MechanismsContent';

const BuildPanelTab: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const buildSubTab = useAppSelector((state) => state.project.loadedProject?.buildSubTab);

  const selectedBuildSubTab: BuildSubTab = isBuildSubTab(buildSubTab) ? buildSubTab : DEFAULT_BUILD_SUB_TAB;

  const setSubTab = useCallback(
    (value: BuildSubTab) => {
      dispatch(projectSlice.actions.setBuildSubTab(value));
    },
    [dispatch]
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Tabs
        value={selectedBuildSubTab}
        onChange={(_, value: BuildSubTab) => setSubTab(value)}
        sx={(theme) => ({
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: 40,
          '& .MuiTabs-flexContainer': { gap: 0, justifyContent: 'center' },
          '& .MuiTab-root': { minHeight: 40, textTransform: 'none', fontSize: '0.875rem' },
          '& .MuiTabs-indicator': { backgroundColor: theme.vars?.palette?.accent?.main },
        })}
      >
        <Tab
          value="add-mechanism"
          label={t('editorDrawer.tabs.mechanisms', 'Mechanisms')}
          aria-label={t('editorDrawer.tabs.mechanisms', 'Mechanisms')}
        />
        <Tab value="add-motor" label={t('editorDrawer.tabs.motors', 'Motors')} aria-label={t('editorDrawer.tabs.motors', 'Motors')} />
        <Tab value="add-sensors" label={t('editorDrawer.tabs.sensors', 'Sensors')} aria-label={t('editorDrawer.tabs.sensors', 'Sensors')} />
        <Tab value="add-other" label={t('editorDrawer.tabs.other', 'Other')} aria-label={t('editorDrawer.tabs.other', 'Other')} />
      </Tabs>
      <Box sx={{ flexGrow: 1, overflowY: 'auto', minHeight: 0 }}>
        {selectedBuildSubTab === 'add-mechanism' && <MechanismsContent />}
        {selectedBuildSubTab === 'add-motor' && (
          <ElectronicsContent
            snippetKey="motors"
            title={t('editorDrawer.tabs.motors', 'Motors')}
            allowedTypes={['motor_plus_high_speed', 'motor_plus_high_torque']}
          />
        )}
        {selectedBuildSubTab === 'add-sensors' && (
          <ElectronicsContent
            snippetKey="sensors"
            title={t('editorDrawer.tabs.sensors', 'Sensors')}
            allowedTypes={['distance_sensor', 'beam_break_sensor', 'magnetic_switch']}
          />
        )}
        {selectedBuildSubTab === 'add-other' && (
          <ElectronicsContent snippetKey="other" title={t('editorDrawer.tabs.other', 'Other')} allowedTypes={['bee_bpr_adapter']} />
        )}
      </Box>
    </Box>
  );
};

export default BuildPanelTab;
